var _rect, _rect2, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 32,
    viewBox: "0 0 51 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Discover"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.5,
    width: 50,
    height: 32,
    rx: 3,
    fill: "#F8F8F8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask Group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2115_11030",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 32
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    x: 0.5,
    width: 50,
    height: 32,
    rx: 3,
    fill: "#F9F9F9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2115_11030)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.9531 32H48.8594C49.7578 32 50.5 31.2578 50.5 30.3594V18.875C47.2578 20.9453 34.9922 28.0547 14.9531 32Z",
    fill: "#F58220"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.22173 12.9717H6.5V18.9848H8.21261C9.12327 18.9848 9.78087 18.77 10.3581 18.2906C11.044 17.723 11.4497 16.8674 11.4497 15.9824C11.4499 14.208 10.1239 12.9717 8.22173 12.9717ZM9.59195 17.4889C9.22335 17.8217 8.74477 17.9668 7.98691 17.9668H7.67218V13.9906H7.98691C8.74477 13.9906 9.20462 14.1261 9.59195 14.4768C9.99763 14.838 10.2416 15.3978 10.2416 15.9736C10.2416 16.551 9.99763 17.1279 9.59195 17.4889Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.1632 12.9717H11.9902V18.9848H13.1632V12.9717Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.0316 15.2799C15.3278 15.0196 15.1211 14.8478 15.1211 14.5229C15.1211 14.1441 15.4893 13.8564 15.9948 13.8564C16.3463 13.8564 16.635 14.0008 16.9406 14.3433L17.5543 13.5398C17.05 13.0986 16.4466 12.873 15.7873 12.873C14.7234 12.873 13.9118 13.6119 13.9118 14.596C13.9118 15.4245 14.2897 15.8486 15.3913 16.245C15.8505 16.4069 16.0842 16.5147 16.2021 16.5873C16.4365 16.7403 16.5538 16.9571 16.5538 17.2095C16.5538 17.6967 16.1665 18.0576 15.6432 18.0576C15.0837 18.0576 14.6331 17.7779 14.3631 17.2557L13.6055 17.9854C14.1459 18.7786 14.7948 19.1302 15.6874 19.1302C16.9062 19.1302 17.7613 18.3198 17.7613 17.1558C17.7611 16.2004 17.3659 15.7678 16.0316 15.2799Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M18.1309 15.9828C18.1309 17.7503 19.5188 19.1208 21.3048 19.1208C21.8098 19.1208 22.2422 19.0215 22.7754 18.7704V17.3897C22.3064 17.8591 21.8912 18.0483 21.3595 18.0483C20.1782 18.0483 19.3398 17.1918 19.3398 15.9741C19.3398 14.8197 20.2048 13.9088 21.305 13.9088C21.8645 13.9088 22.2879 14.1085 22.7756 14.5854V13.2053C22.2607 12.9441 21.8375 12.8359 21.3327 12.8359C19.5553 12.8362 18.1309 14.2346 18.1309 15.9828Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M32.0744 17.0107L30.4708 12.9717H29.1895L31.7415 19.1392H32.3726L34.9703 12.9717H33.6988L32.0744 17.0107Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M35.5 18.9858H38.8264V17.968H36.672V16.3449H38.747V15.3262H36.672V13.9916H38.8264V12.9727H35.5V18.9858Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M43.4707 14.7469C43.4707 13.6211 42.6953 12.9717 41.3426 12.9717H39.6035V18.9848H40.775V16.5693H40.928L42.5514 18.9849H43.9939L42.101 16.4515C42.9843 16.2719 43.4707 15.6677 43.4707 14.7469ZM41.1177 15.7401H40.7751V13.9188H41.1362C41.8667 13.9188 42.2639 14.2249 42.2639 14.8101C42.2639 15.4147 41.8668 15.7401 41.1177 15.7401Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("g", {
    id: "MarkingBase 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M26.3571 19.1985C28.1237 19.1985 29.5559 17.7663 29.5559 15.9996C29.5559 14.233 28.1237 12.8008 26.3571 12.8008C24.5904 12.8008 23.1582 14.233 23.1582 15.9996C23.1582 17.7663 24.5904 19.1985 26.3571 19.1985Z",
    fill: "url(#paint0_linear_2115_11030)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    opacity: 0.65,
    d: "M26.3571 19.1985C28.1237 19.1985 29.5559 17.7663 29.5559 15.9996C29.5559 14.233 28.1237 12.8008 26.3571 12.8008C24.5904 12.8008 23.1582 14.233 23.1582 15.9996C23.1582 17.7663 24.5904 19.1985 26.3571 19.1985Z",
    fill: "url(#paint1_linear_2115_11030)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Registered 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M44.2214 13.1982C44.2214 13.0928 44.1488 13.0352 44.0213 13.0352H43.8516V13.5637H43.9777V13.3586L44.1256 13.5637H44.2795L44.1057 13.3458C44.1804 13.3258 44.2214 13.2716 44.2214 13.1982ZM43.9991 13.2705H43.9778V13.1323H44.0004C44.0628 13.1323 44.0953 13.1547 44.0953 13.2003C44.0953 13.2468 44.0624 13.2705 43.9991 13.2705Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M44.0463 12.8379C43.7896 12.8379 43.5859 13.0427 43.5859 13.2986C43.5859 13.5545 43.7919 13.7595 44.0463 13.7595C44.2963 13.7595 44.5011 13.5522 44.5011 13.2986C44.5011 13.0461 44.2962 12.8379 44.0463 12.8379ZM44.0442 13.6771C43.8423 13.6771 43.6771 13.509 43.6771 13.2993C43.6771 13.0888 43.8402 12.9209 44.0442 12.9209C44.2453 12.9209 44.4091 13.0927 44.4091 13.2993C44.4091 13.5072 44.2455 13.6771 44.0442 13.6771Z",
    fill: "#231F20"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2115_11030",
    x1: 27.9944,
    y1: 18.5633,
    x2: 25.7796,
    y2: 15.0955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89F21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2502,
    stopColor: "#F79A23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5331,
    stopColor: "#F78E22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6196,
    stopColor: "#F68721"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7232,
    stopColor: "#F48220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F27623"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2115_11030",
    x1: 27.6446,
    y1: 18.5161,
    x2: 24.4075,
    y2: 12.1891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68721",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3587,
    stopColor: "#E27027",
    stopOpacity: 0.2704
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    stopColor: "#D4612C",
    stopOpacity: 0.5299
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#D15D2D",
    stopOpacity: 0.74
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.2394677e9ba7030861879c19e3caaa76.svg";
export { ForwardRef as ReactComponent };